var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"up-button"},on:{"click":_vm.goTop}},[(_vm.showButton)?_c('div',{staticClass:"wrapper"},[_c('img',{staticClass:"arrow-img",attrs:{"src":"/static/icons/UpButton.svg"}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }